import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, signInWithEmailAndPassword } from 'firebase/auth';
import { FaEye, FaEyeSlash, FaArrowLeft } from 'react-icons/fa';
import { requestSignin } from './scripts.js';
import { startAuthRefresh } from './Session.js';
import { useSpinner } from '../../Widgets/Spinner';
import { useToast } from '../../Widgets/Toast';
import { useNavigate } from '@tanstack/react-router';
import { environment } from '@/env/env.prod';

// Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyBdxIpFnajPcsqK2Dv1f8zuGCjcwBf9b5Q",
  authDomain: "chatapp-55d4a.firebaseapp.com",
  databaseURL: "https://chatapp-55d4a-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "chatapp-55d4a",
  storageBucket: "chatapp-55d4a.appspot.com",
  messagingSenderId: "496473934638",
  appId: "1:496473934638:web:64221c6c5c8d9a909488bf",
  measurementId: "G-3C9KY0KEKM"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

if (environment.USE_EMULATORS) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
}

function getFriendlyErrorMessage(error) {
  const message = (error?.message || "").toLowerCase();
  if (message.includes("user not found")) return "User not found. Please check your ID or register.";
  if (message.includes("wrong password")) return "Incorrect password. Please try again.";
  if (message.includes("network error")) return "Network error. Please check your connection.";
  if (message.includes("too many attempts")) return "Too many login attempts. Please try again later.";
  return "An unexpected error occurred. Please try again.";
}

function AuthDialog() {

  const navigate = useNavigate();

  const [ form, setForm ] = useState({
    email: "",
    password: "",
    insCode: "",
    userId: ""
  });

  const [ showPassword, setShowPassword ] = useState(false);

  const { setLoading } = useSpinner();
  const { showToast } = useToast();

  const handleBack = () => {
    navigate({ to: '/' });
  };

  const handleSignIn = async () => {

    const { email, password, insCode, userId } = form;

    if (!email || !password || !insCode || !userId) {
      showToast("Please fill in all fields.", "error");
      return;
    }

    setLoading(true);

    try {

      const { user } = await signInWithEmailAndPassword(auth, email, password);

      const idToken = await user.getIdToken();
      const refreshToken = user.refreshToken;

      Cookies.set("refreshToken", refreshToken);
      Cookies.set("refreshTokenTimestamp", Date.now().toString());
      Cookies.set("mail", email);

      const result = await requestSignin({
        authToken: idToken,
        id: userId,
        ins_code: insCode,
        user_id: user.uid
      });

      if (!result) {
        showToast("Error occurred while signing in.", "error");
        return;
      }

      startAuthRefresh();
      showToast("Logged in successfully.", "success");
      navigate({ to: '/dashboard' });

    } catch (error) {
      showToast(getFriendlyErrorMessage(error), "error");
    }
    finally {
      setLoading(false);
    }
  };

  return (

    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg,#ffde59,#8b3b05)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
      }}
    >

      <button
        onClick={handleBack}
        style={{
          position: "absolute",
          top: "30px",
          left: "30px",
          background: "#fff5e0",
          border: "1px solid #e6d5b8",
          borderRadius: "10px",
          padding: "10px",
          cursor: "pointer",
          color: "#3e2f25",
          fontSize: "16px"
        }}
      >
        <FaArrowLeft />
      </button>

      <div
        style={{
          background: "#fff5e0",
          padding: "40px",
          borderRadius: "16px",
          border: "1px solid #e6d5b8",
          width: "380px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)"
        }}
      >

        <h2
          style={{
            marginBottom: "20px",
            color: "#3e2f25",
            fontWeight: "600",
            textAlign: "center"
          }}
        >
          Sign In
        </h2>

        <label style={{ color: "#3e2f25", fontSize: "13px" }}>
          Institute Code
        </label>

        <input
          type="text"
          placeholder="e.g. ABC123"
          value={form.insCode}
          onChange={(e) => setForm({ ...form, insCode: e.target.value })}
          style={inputStyle}
        />

        <label style={labelStyle}>User ID</label>

        <input
          type="text"
          placeholder="e.g. TCHR-001"
          value={form.userId}
          onChange={(e) => setForm({ ...form, userId: e.target.value })}
          style={inputStyle}
        />

        <label style={labelStyle}>Email</label>

        <input
          type="email"
          placeholder="name@example.com"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          style={inputStyle}
        />

        <label style={labelStyle}>Password</label>

        <div style={{ position: "relative" }}>

          <input
            type={showPassword ? "text" : "password"}
            placeholder="••••••••"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            style={inputStyle}
          />

          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#3e2f25"
            }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>

        </div>

        <button
          onClick={handleSignIn}
          style={{
            marginTop: "20px",
            width: "100%",
            padding: "12px",
            borderRadius: "10px",
            border: "none",
            background: "#ffcb77",
            color: "#3e2f25",
            fontWeight: "600",
            cursor: "pointer",
            fontSize: "15px"
          }}
        >
          Sign In
        </button>

      </div>

    </div>
  );
}

const labelStyle = {
  color: "#3e2f25",
  fontSize: "13px"
};

const inputStyle = {
  width: "100%",
  marginBottom: "14px",
  marginTop: "6px",
  padding: "10px",
  borderRadius: "8px",
  border: "1px solid #e6d5b8",
  background: "#fff",
  fontSize: "14px"
};

export default AuthDialog;